import React, {Component} from "react";
import {logout} from '../../helpers/auth';
import { NavLink } from 'react-router-dom';


export default class Nav extends Component {

	render() {
		return(
			<nav className="navbar navbar-default navbar_deng">
			  <div className="container">

			    <div className="navbar-header">
			      <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#mobile_menu" aria-expanded="false">
			        <span className="sr-only">Toggle navigation</span>
			        <span className="icon-bar"></span>
			        <span className="icon-bar"></span>
			        <span className="icon-bar"></span>
			      </button>
			      <NavLink className="navbar-brand" to="/">ADMIN - ANDRIDENG</NavLink>
			    </div>

			    <div className="collapse navbar-collapse" id="mobile_menu">
			      <ul className="nav navbar-nav navbar-right">
					
					<li><NavLink to="/_admin/about">About</NavLink></li>
					<li><NavLink activeClassName="active" to="/_admin/skills">Skills</NavLink></li>
					<li><NavLink to="/_admin/experience">Experience</NavLink></li>
					<li><NavLink to="/_admin/education">Education</NavLink></li>
					<li><NavLink to="/_admin/awards">Awards</NavLink></li>
					<li><NavLink to="/_admin/portfolio">Portfolio</NavLink></li>
					<li><a onClick={ () => {logout()} }>Logout</a></li>
					
			      </ul>
			    </div> 
			  </div>
			</nav>
		       
		);
	}
}



// WEBPACK FOOTER //
// ./src/auth_pages/components/Nav.js